// extracted by mini-css-extract-plugin
export default {"tag":"commonStyles_tag__Ez3fA","tagRow":"commonStyles_tagRow__LhM0Y","lead":"commonStyles_lead__qNc6v"};